import React , { useState, useContext } from 'react'
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import "../styles/loginUI.css";
import {Link, useNavigate} from "react-router-dom";
import { UserContext } from './UserContext';

const LoginUI = () => {
var navigate = useNavigate();
const [userName, setUserName] = useState ("");
const [password, setPassword] = useState ("");
const [name,setName] = useState("");
const { user, setUser} = useContext(UserContext);

    const redirect = () =>{
		if(userName.length === 0){
			return	alert("Please Enter Email!!");
			}
		if(password.length === 0){
			return	alert("Please Enter Password!!");
			}
        const apiUrl = process.env.REACT_APP_API_URL + "/users/login";
        var apiParam = {
          method: 'POST',
          headers: { email: userName, password: password },
          credentials: 'same-origin'
        };
        fetch(apiUrl, apiParam)
          .then((res) => (res.status === 200 ? res.json() : res.text()))
          .then((repos) => {
            if (repos.data) {
				console.log(repos.data)
              localStorage.setItem("loggedintoken", repos.data);
              localStorage.setItem("loggedInUser", atob(repos.data.split(".")[1]));
              setUser(JSON.parse(atob(repos.data.split(".")[1])))
              setName(JSON.parse(atob(repos.data.split(".")[1])).name)
              navigate("/home");
            } else alert(JSON.stringify(repos));
          })
          .catch((err) => alert(JSON.stringify(err)));
      };



  return (
    <>
<div id="index_page">
	<svg class="Ellipse_1">
		<ellipse id="Ellipse_1" rx="545" ry="529.5" cx="545" cy="529.5">
		</ellipse>
	</svg>
	<svg class="Ellipse_2">
		<ellipse id="Ellipse_2" rx="545" ry="529.5" cx="545" cy="529.5">
		</ellipse>
	</svg>
	<svg class="Ellipse_3">
		<ellipse id="Ellipse_3" rx="586.5" ry="548.5" cx="586.5" cy="548.5">
		</ellipse>
	</svg>
	<img id="slazzer-edit-image1" src="slazzer-edit-image1.png" srcset="slazzer-edit-image1.png 1x, slazzer-edit-image1@2x.png 2x" />
		
	<div onClick={()=>navigate('/sendmail')} id="Forgot_Password_login">
		<span>Forgot Password?</span>
	</div>
	<div onClick={()=>navigate('/signup')} id="Dont_have_an_Account">
		<span>Sign-Up for Free!!</span>
	</div>
	<button id="Login_button_PC" tabIndex={3} onClick={()=>redirect()}>
		<svg class="Login_Color_high">
			<rect id="Login_Color_high" rx="19.5" ry="19.5" x="0" y="0" width="155" height="39">
			</rect>
		</svg>
		<div id="LOGIN_N">
			<span>LOGIN </span>
		</div>
	</button>
	<img id="imageloginLogo" src="image.png" srcset="image.png 1x, image@2x.png 2x" />
		
	<input placeholder="Password" type="password" tabIndex={2} class="txtPassword_PC" value={password}  onChange={(e)=>setPassword(e.target.value)} />
	
	<input placeholder="Email" type="email" class="txtEmail_PC" tabIndex={1} value={userName} onChange={(e)=>setUserName(e.target.value)} />
		
	<div id="OPERATE_LIVE_Login">
		<span>OPERATE </span><span style={{color:"red"}}>LIVE</span>
	</div>
</div>


   </> 
  )
}

export default LoginUI